import React from "react";
import { Route } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./App.css";
import Home from "./components/";
import Resume from "./components/Resume";
import Portfolio from "./components/Portfolio";
import Contacts from "./components/ContactForm";
import { ToastContainer } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
/*
      About CSSBaseLine
If you’ve been writing front-end code, you should already know what aboutnormalize.css. 
If not, it’s a collection of HTML element and attribute style normalizations. 
Material-UI provides its own version of normalize.css which is CssBaseline,
 a component that provides an elegant, consistent, and simple baseline to build upon.
The CSSBaseline does the following:

The margin in all browsers is removed
The default Material Design background color is applied
Font antialiasing is enabled for better display of the Roboto font
No base font-size is declared on the <html>, but 16px is assumed (browser default)
*/

function App() {
  return (
    <>
      <ToastContainer />
      <CssBaseline />
      <Route exact path="/" component={Home} />
      <Route path="/resume" component={Resume} />
      <Route path="/portfolio" component={Portfolio} />
      <Route path="/contact" component={Contacts} />
    </>
  );
}

export default App;
